import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class CheckoutConfigGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const origin = (this.authService.getOriginCurrency?.() || 'BRL').toUpperCase();

    if (origin === 'BRL') {
      this.toastr.error('Tela disponível apenas para contas internacionais.');
      this.router.navigate(['/reports']);
      return false;
    }

    return true;
  }
}
